import { Translate } from '@teliaee/telia-translate';
import { IFormHelperProps } from '@teliaee/design-system';

export const ERRORED_HELPER_FIELD_ID_SUFFIX = '-invalid';

export const removeIdIndexFromString = (string: string) => {
  return string.replace(/-\d+$/, '');
};

export const getPhoneFieldHelper = (isValid: boolean, hasNoPlans: boolean, translate: Translate): IFormHelperProps | null => {
  const errorLabel = !isValid ? 'prepaid.validation.incorrect' : hasNoPlans ? 'prepaid.validation.no-plan' : null;

  if (errorLabel) {
    return { type: 'error', text: translate(errorLabel), id: 'prepaidPhone' };
  }

  return null;
};

export const getEmailFieldHelper = (isValid: boolean, translate: Translate): IFormHelperProps | null => {
  const errorLabel = !isValid ? 'prepaid.validation.email-error' : null;

  if (errorLabel) {
    return { type: 'error', text: translate(errorLabel), id: 'order-invoice-email-textfield' };
  }

  return null;
};

export const getPersonalCodeFieldHelper = (isValid: boolean, translate: Translate): IFormHelperProps | null => {
  const errorLabel = !isValid ? 'prepaid.validation.incorrect' : null;

  if (errorLabel) {
    return { type: 'error', text: translate(errorLabel), id: 'personalCode' };
  }

  return null;
};
